import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useOfferLandingPageViewModel } from '../view-model/offerViewModel';
import { LandingPageBuilderView } from './LandingPageBuilderView';

export const offerLandingPageViewModel = registerContext(
  'OfferLandingPageViewModel',
  useOfferLandingPageViewModel,
);

export const OfferLandingPageBuilder = (p: {
  programId: number;
  offerId: number;
  creatorId: number;
}) => (
  <offerLandingPageViewModel.ValueProvider
    params={p}
    renderer={LandingPageBuilderView}
  />
);
